require('./formGetKey.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const includes = require('lodash/collection/includes');

// @ components
const { OKButton } = require('components/commons/OKButton/OKButton');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { PasswordPositions } = require('components/contactCenter/passwordPositions/passwordPositions');
const { FormattedText, formatText } = require('core/i18n').i18n;

class FormGetKey extends React.Component {
    constructor(props) {
        super(props);
        this.handleOnInputDigit = this.handleOnInputDigit.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
        this.state = {
            positions: null,
            values: null
        };
    }

    handleOnInputDigit({ positions,  values }) {
        this.setState({
            positions,
            values
        });
    }

    handleConfirm() {
        const { positions, values } = this.state;
        const { requestClientPinValidation } = this.props;

        if (this.canConfirm()) {
            requestClientPinValidation(positions, values);
        }
    }

    canConfirm() {
        const { values } = this.state;

        return values && !includes(values, '');
    }

    render() {
        const { documentId, documentType, isFetching, documentTypeCode, isInvalidPasswordError, isPasswordBlockedError } = this.props;

        const promptId = formatText('loginAsClient-promptId');
        const btnAccess = formatText('loginAsClient-btnAccess');

        return (
            <div className="form-get-key">
                <div className="form-get-key__body">
                    <div className="form-get-key__item-wrap">
                        <BlockInfo extraClass="form-get-key__prompt">
                            {promptId}
                        </BlockInfo>
                        <div className="form-get-key__info-section">
                            <div className="form-get-key__info">
                                <FormattedText className="form-get-key__info-label" value="loginAsClient-labelIdType"/>
                                <br/>
                                <span className="form-get-key__info-value">{documentType}</span>
                            </div>
                            <div className="form-get-key__info form-get-key__id-number">
                                <FormattedText className="form-get-key__info-label" value="loginAsClient-labelIdNumber"/>
                                <br/>
                                <span className="form-get-key__info-value">{documentId}</span>
                            </div>
                        </div>
                    </div>

                    <div className="form-get-key__item-wrap">
                        <PasswordPositions
                            documentType={documentTypeCode}
                            documentNumber={documentId}
                            className="form-get-key__password-positions"
                            onInputDigit={this.handleOnInputDigit}
                            onEnterKey={this.handleConfirm}
                            disabled={isFetching}
                            isInvalidPasswordError={isInvalidPasswordError}
                            isPasswordBlockedError={isPasswordBlockedError}
                        />
                    </div>
                </div>

                <hr/>

                <div className="form-get-key__footer">
                    <div className="form-get-key__footer-right">
                        <OKButton
                            modifier="primary"
                            disabled={!this.canConfirm()}
                            onClick={this.handleConfirm}
                            loading={isFetching}>
                            {btnAccess}
                        </OKButton>
                    </div>
                </div>
            </div>
        );
    }
}

FormGetKey.propTypes = {
    documentId: PropTypes.string.isRequired,
    documentType: PropTypes.string.isRequired,
    documentTypeCode: PropTypes.string.isRequired,
    requestClientPinValidation: PropTypes.func.isRequired,
    isFetching: PropTypes.bool.isRequired,
    isInvalidPasswordError: PropTypes.bool.isRequired,
    isPasswordBlockedError: PropTypes.bool.isRequired
}

module.exports = FormGetKey;
